import { fetchWithToken } from '../../../api/apiutils';

export const getPaidFilters = async () => {
  const res = await fetchWithToken('/api/filter/paidFilter');

  if (!res.ok) {
    const text = await res.text().catch(() => 'Ошибка сервера');
    throw new Error(`Ошибка загрузки платных фильтров: ${text}`);
  }

  return await res.json();
};
